'use strict';

var GridFeaturesController = function GridFeaturesController($scope) {
  $scope.initFeatureWrapper = function () {
    $scope.gridFeatures = $scope.$parent.jqxGridFeatures;
    $scope.gridFeaturesModel = $scope.$parent.gridFeaturesModel;
    $scope.gridEventHandlers = $scope.$parent.jqxGridEventHandlers;
    $scope.gridPanelScope = $scope.$parent;
  };
  $scope.initFeatureWrapper();
};
GridFeaturesController.$inject = ['$scope'];
module.exports = GridFeaturesController;